import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api.service';

interface SAPState {
    items: any[];
    serviceItems: any[];
    projects: any[];
    accounts: any[];
    vendors: any[];
    isLoading: boolean;
}

const initialState: SAPState = {
    items: [],
    serviceItems: [],
    projects: [],
    accounts: [],
    vendors: [],
    isLoading: false,
};

export const fetchItems = createAsyncThunk('sap/fetchItems', async () => {
    const response = await apiService.getItems();
    return response.data;
});

export const fetchServiceItems = createAsyncThunk('sap/fetchServiceItems', async () => {
    const response = await apiService.getServiceItems();
    return response.data;
});

export const fetchProjects = createAsyncThunk('sap/fetchProjects', async () => {
    const response = await apiService.getProjects();
    return response.data;
});

export const fetchAccounts = createAsyncThunk('sap/fetchAccounts', async () => {
    const response = await apiService.getAccounts();
    return response.data;
});

export const fetchVendors = createAsyncThunk('sap/fetchVendors', async () => {
    const response = await apiService.getVendors();
    return response.data;
});

const sapSlice = createSlice({
    name: 'sap',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchItems.fulfilled, (state, action) => {
            state.items = action.payload;
        });
        builder.addCase(fetchServiceItems.fulfilled, (state, action) => {
            state.serviceItems = action.payload;
        });
        builder.addCase(fetchProjects.fulfilled, (state, action) => {
            state.projects = action.payload;
        });
        builder.addCase(fetchAccounts.fulfilled, (state, action) => {
            state.accounts = action.payload;
        });
        builder.addCase(fetchVendors.fulfilled, (state, action) => {
            state.vendors = action.payload;
        });
    },
});

export default sapSlice.reducer;
